export const getUsername = () => {
  try {
    return localStorage.getItem("userName");
  } catch (error) {
    console.error("Error accessing localStorage:", error);
    return null;
  }
};

export const showError = (message) => {
  // Example: using Snackbar or Toast provider
  const event = new CustomEvent("showSnackbar", {
    detail: { message, type: "error" },
  });
  window.dispatchEvent(event);
};
